export default {"src":"/_next/static/media/yellow_bulb.d4c9820e.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};